import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel';

import styles from './RelatedPhotosHeader.scss';

import { type PhotoTagType } from './types';

type Props = {
    roomTag?: PhotoTagType | null;
};

const RelatedPhotosHeader: FC<Props> = props => {
    const { roomTag } = props;
    const displayName = roomTag?.name;

    return (
        <HeadingLevel>
            {Heading => (
                <Heading className={styles.heading}>
                    {displayName ? (
                        <FormattedMessage
                            id="interiorPhoto.relatedPhotos.header"
                            defaultMessage="Explore More {displayName} Photos"
                            values={{ displayName }}
                        />
                    ) : (
                        <FormattedMessage
                            id="interiorPhoto.relatedPhotos.headerFallback"
                            defaultMessage="Explore More Rooms"
                        />
                    )}
                </Heading>
            )}
        </HeadingLevel>
    );
};

export default RelatedPhotosHeader;
